import { z } from 'zod';

import { schemaApplicantAttribution, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const EinkuenfteAusNebentaetigkeit = z.object({
    beginnDerTaetigkeit: z.coerce.date().nullish().default(null),
    betragMonatlich: schemaBigDecimal.nullish().default(null),
    gehoertZuAntragsteller: schemaApplicantAttribution, // TODO - hier konnte angegeben werden das es zu beiden gehört was aber falsch ist (zumindest bei europace)
    id: schemaId, // TODO - id war im yup schema optional, was aber falsch ist, oder?
});
